const styles = (theme) => ({
  containerValueProgress: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  containerComponent: { position: "relative", display: "inline-flex" },
});

export default styles;
